"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AircraftBackCircleLinear = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var AircraftBackCircleLinear = function AircraftBackCircleLinear(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.436 30.708c0-.837.274-1.623.847-2.204.575-.583 1.365-.871 2.227-.871h7.882L34.545 15.48a1 1 0 01.707-.293H39.4a1 1 0 01.833 1.555l-7.26 10.89h4.976l3.856-3.855a1 1 0 01.707-.293h3.111a1 1 0 01.848 1.53l-3.557 5.69L46.47 36.4a1 1 0 01-.848 1.53h-3.111a1 1 0 01-.707-.293l-3.856-3.856h-4.977l7.26 10.89a1 1 0 01-.831 1.556h-4.149a1 1 0 01-.707-.293L22.392 33.78H14.51c-.862 0-1.652-.288-2.227-.87-.573-.581-.847-1.367-.847-2.203zm3.074-1.075c-.413 0-.66.13-.803.276-.146.147-.271.398-.271.799 0 .4.125.65.27.797.144.146.391.276.804.276h8.297a1 1 0 01.707.293l12.152 12.153h1.866l-7.26-10.891a1 1 0 01.832-1.555h7.26a1 1 0 01.707.293l3.855 3.856h.894l-2.934-4.697a1 1 0 010-1.06l2.932-4.689h-.892l-3.855 3.856a1 1 0 01-.708.293h-7.26a1 1 0 01-.831-1.555l7.26-10.89h-1.866L23.514 29.34a1 1 0 01-.707.293H14.51z",
    fill: "url(#AircraftBackCircleLinear_svg__AircraftBackCircleLinear_svg__paint0_linear_17373_95659)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.787 51.213c11.715 11.716 30.71 11.716 42.426 0 11.716-11.716 11.716-30.71 0-42.426-11.716-11.716-30.71-11.716-42.426 0-11.716 11.715-11.716 30.71 0 42.426zm1.414-1.414c10.935 10.934 28.663 10.934 39.598 0 10.934-10.935 10.934-28.663 0-39.598C38.864-.734 21.136-.734 10.2 10.201-.735 21.136-.735 38.864 10.2 49.799z",
    fill: "url(#AircraftBackCircleLinear_svg__AircraftBackCircleLinear_svg__paint1_linear_17373_95659)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "AircraftBackCircleLinear_svg__AircraftBackCircleLinear_svg__paint0_linear_17373_95659",
    x1: 0,
    y1: 60,
    x2: 63.502,
    y2: 56.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AircraftBackCircleLinear_svg__AircraftBackCircleLinear_svg__paint1_linear_17373_95659",
    x1: 0,
    y1: 60,
    x2: 63.502,
    y2: 56.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB784"
  }))));
};

exports.AircraftBackCircleLinear = AircraftBackCircleLinear;
var _default = AircraftBackCircleLinear;
exports.default = _default;